import React from "react";
import { Helmet } from "react-helmet";
import "../../css/investor-file.css";
import reportPdf from "../../pdf/Report-Final.pdf";
import NoticeAGM from "../../pdf/Notice-AGM.pdf";

const InvestorFile = () => {
  return (
    <>
      <Helmet>
        <title>Investor File Rudra Global Infra Products, Bhavanagar</title>
      </Helmet>
      <div>
        <section className="investor-file">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                <div class="card h-100">
                  <a href="https://storage.googleapis.com/rudratmx-firebase.appspot.com/1788335029900_Annual_Report_FY_2025-26_7925.pdf" target="_blank" rel="noopener noreferrer">
                    <p class="card-text">Report</p>
                  </a>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                <div class="card h-100">
                  <a href="https://storage.googleapis.com/rudratmx-firebase.appspot.com/1788333996590_Notice_FY2025-26_8252.pdf" target="_blank" rel="noopener noreferrer">
                    <p class="card-text">Notice</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default InvestorFile;
